"use client";

import { Select } from "../../primitives";
import type { CsatBenchmark } from "./data";

interface IndustrySelectProps {
  value: string;
  onChange: (slug: string) => void;
  industries: CsatBenchmark[];
  className?: string;
}

export function IndustrySelect({
  value,
  onChange,
  industries,
  className,
}: IndustrySelectProps) {
  return (
    <Select
      name="industry"
      aria-label="Select industry to benchmark against"
      options={industries.map((b) => ({ value: b.slug, label: b.industry }))}
      value={value}
      onValueChange={(next) => onChange(next as string)}
      className={className}
      triggerProps={{
        className:
          "!h-auto !w-[245px] !gap-2 !rounded-full !border-current/20 !bg-transparent !px-4 !py-1.5 !text-label-lg !text-current",
      }}
    />
  );
}
